import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject } from "@angular/core";

import { environment } from "@environments/environment";

import { TenantUtilities } from "@core/utilities";


export abstract class AbstractApiServiceBase {
  
  protected http: HttpClient;

  constructor() {
    this.http = inject(HttpClient);
  }

  public get tenantName(): string {
    return TenantUtilities.getTenantFromRoute();
  }

  protected getBaseApiUrl(apiVersion: string | undefined = undefined): string {
    const url: string = `${environment.apiUrl}/${apiVersion ? apiVersion + '/' : ''}${this.tenantName}`;
    return url;
  }

  protected getJsonHeader(): HttpHeaders {
    return new HttpHeaders()
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('Accept', 'application/json');
  }

  protected getPdfHeader(): HttpHeaders {
    return new HttpHeaders()
      .set('Accept', 'application/pdf');
  }

  protected getCsvHeader(): HttpHeaders {
    return new HttpHeaders()
      .set('Accept', 'text/csv');
  }
}